import { render, staticRenderFns } from "./collectionLog.vue?vue&type=template&id=7765f78b&scoped=true"
import script from "./collectionLog.vue?vue&type=script&lang=ts"
export * from "./collectionLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7765f78b",
  null
  
)

export default component.exports